import { Components, Theme } from '@mui/material/styles'

export const MuiButtonOverrides: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      textTransform: 'none',
      borderRadius: '9999px', // Always creates pill shape (half of height)
      minHeight: 40,
    }),
    contained: {
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      '&:hover': {
        boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
      },
    },
    outlined: {
      borderWidth: 2,
      '&:hover': {
        borderWidth: 2,
      },
    },
  },
}
